import './mail-close-workspace.ajscss';

import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IEpticaRequestFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IComponentController, IComponentOptions, IPromise } from 'angular';
import { i18n } from 'i18next';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './mail-close-workspace.template.html';

export class MailCloseWorkspaceCtrl extends DisplayDeprecatedComponent implements IComponentController {
  responseId: string;
  private requestPromise: IPromise<IEpticaRequestFrame>;
  comment: string;
  private request: any;

  constructor(
    protected readonly contactDeprecatedService: IContactDeprecatedService,
    protected readonly epticaDeprecatedService: IEpticaDeprecatedService,
    protected $i18next: i18n
  ) {
    super();
  }

  $onInit(): void {
    this.requestPromise = this.contactDeprecatedService.getContact(this.responseId).then(contact =>
      this.epticaDeprecatedService.loadRequest({
        requestId: contact.epticaRequestId || 0,
        responseId: this.responseId,
      })
    );
    this.requestPromise.then(request => {
      this.request = request;
      setTimeout(() => {
        this.request.hide();
      }, 500);
    });
    $('#Area-WorkZone-Core-parent').removeClass('grid2');
  }

  mainPromise(): IPromise<IEpticaRequestFrame> {
    return this.requestPromise;
  }
}

export class MailCloseWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = ['contactDeprecatedService', 'epticaDeprecatedService', '$i18next', MailCloseWorkspaceCtrl];
}

export default 'contactMailCloseWorkspace';
